// extracted by mini-css-extract-plugin
export var optionGrid = "_5q-7";
export var optionList = "_5q-6";
export var questionsBlock = "_5q-9";
export var spacer = "_5q-5";
export var stepCenteredContent = "_5q-3";
export var stepInner = "_5q-0";
export var stepInnerFullWidth = "_5q-1";
export var stepInnerLockScroll = "_5q-2";
export var stepTransitionFrame = "_5q-4";
export var welcomeBlock = "_5q-8";